import axios from "axios";
import { getHeaders } from "services/AuthHeader";
import { ResponseError } from "types/responses/ResponseError";

const API_URL = process.env.REACT_APP_API_URL;

export async function CreateOnlineAccountService(email: string, language: any) {
    try {
        const response = await axios.post(
            API_URL + '/create_online_accout',
            {
                email: email,
                language: language,
                return_url: window.location.href   
            }, {
                headers: getHeaders()
            }
        )
        // console.log(response);
        
        
        if ("error" in response.data) {
            return response.data.error
        }
        if ("user" in response.data) {
            return response.data.user
        }

    } catch (error) {
        return ResponseError.general_error
    }
}